import Image from 'next/image';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';

// interface IQuestionRightProps {
//   isHappy: boolean;
// }
const HomePageQuestionRight: FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <div className=" mt-3 flex  min-h-full flex-col items-stretch lg:mt-10  " data-sentry-component="HomePageQuestionRight" data-sentry-source-file="HomePageQuestionRight.tsx">
      <div className="leading-5 text-md w-full max-w-[265px] py-2 pl-4 font-pelak font-bold text-orangeSix">
        سوالاتی که شما پرسیدین...
      </div>

      <p className="mb-4 ">
        <span className="text-2xl font-bold text-orangeSix drop-shadow-homePageQuestion lg:text-3xl">
          جواب همۀ سوالات اینجاست!
        </span>
      </p>
      {!isMobile ? <div className="lg:-mb-20 lg:mt-28">
          <Image width={512} height={584} src={`${FILE_BROWSER_URL}/img/question-homePage-desktop.svg`} alt="عکس در حال جستجو" />
        </div> : <div className="lg:-mb-20 lg:mt-28">
          <Image width={512} height={584} src={`${FILE_BROWSER_URL}/img/question-homePage-mobile.svg`} alt="عکس در حال جستجو" />
        </div>}
    </div>;
};
export default HomePageQuestionRight;